import { keyMirror } from 'ramda-extension';

export const privilegesAction = keyMirror({
	VIEW: null,
	UPDATE: null,
	CREATE: null,
	DELETE: null,
});
